// This file is auto-generated. Do not edit manually.
// Version is updated automatically during deployment.

// @ts-ignore - Vite injects these at build time
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || "1.0.0";
// @ts-ignore - Vite injects these at build time
export const APP_BUILD_DATE: string = import.meta.env.VITE_APP_BUILD_DATE || new Date().toISOString().split("T")[0];
